import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import { AssignMonthCloseComponent } from '../../../../assign-month-close/assign-month-close.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AssignMonthCloseComponent, TooltipDirective, RouterLink],
  selector: 'aux-checklist-banner',
  templateUrl: './checklist-banner.component.html',
})
export class ChecklistBannerComponent {
  @Input() disabled = false;
  readonly routerLink = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.CLOSE_SUMMARY}`;
}
